import FingerprintJS from '@fingerprintjs/fingerprintjs'
const axios = require('axios').default;

class UserIdentifyHelper {
    async get() {
        const fpPromise = await FingerprintJS.load();
        const fp = await fpPromise
        const result = await fp.get();

        const {data} = await axios.post('/fingerprint',{visitorId: result.visitorId}, {
            headers: {
                'Content-Type': 'application/json'
            }
        })

        return data;
    }
}

export const userIdentifyHelper = new UserIdentifyHelper();
